import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, catchError, throwError } from 'rxjs';

import { API_URL } from '../../injection-tokens';
import { ProblemDetails, QrtApiError, QrtReportResponse, ReportParameterRequest, ReportRequest } from './qrt-api.types';

@Injectable({ providedIn: 'root' })
export class QrtApiService {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = inject(API_URL);
    private readonly reportEndpoint = this.buildReportEndpoint();

    generateReport(reportId: string, parameters?: ReportParameterRequest[]): Observable<QrtReportResponse> {
        const request: ReportRequest = {
            guid: reportId,
            ...(parameters !== undefined ? { parameters } : {}),
        };

        return this.http.post<QrtReportResponse>(this.reportEndpoint, request).pipe(
            catchError((error: HttpErrorResponse) => {
                const problemDetails = this.getProblemDetails(error.error);
                const qrtError: QrtApiError = {
                    status: error.status,
                    message: this.getErrorMessage(error, problemDetails),
                    problemDetails,
                    originalError: error,
                };

                return throwError(() => qrtError);
            }),
        );
    }

    private buildReportEndpoint(): string {
        const trimmedApiUrl = this.apiUrl.replace(/\/$/, '');
        return `${trimmedApiUrl}/qrt/Report`;
    }

    private getProblemDetails(value: unknown): ProblemDetails | undefined {
        if (!value || typeof value !== 'object') {
            return undefined;
        }

        const candidate = value as ProblemDetails;
        if (
            'type' in candidate ||
            'title' in candidate ||
            'status' in candidate ||
            'detail' in candidate ||
            'instance' in candidate
        ) {
            return candidate;
        }

        return undefined;
    }

    private getErrorMessage(error: HttpErrorResponse, problemDetails?: ProblemDetails): string {
        if (problemDetails?.title) {
            return problemDetails.title;
        }

        if (error.status === 0) {
            return 'Network error while calling QRT Report endpoint.';
        }

        return 'QRT Report request failed.';
    }
}